import { getClassroomApiUrl } from "@/js/utils/getBackendUrl";
import * as clsApi from "@/js/api/classroomApi";

export async function addStudentToClassroom(
	teacherId: string,
	studentQID: string,
	classroomOrGroupId: string,
	classroomType: "classroom" | "group",
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<void> {
	const response = await fetch(
		`${host}/v1/appliances/${authHeaders.Device}/${classroomType}s/${classroomOrGroupId}/students/${studentQID}`,
		{
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				user: teacherId,
				Authorization: authHeaders.Authorization,
				Device: authHeaders.Device,
			},
		}
	);

	if (!response.ok) {
		throw new Error(`Failed to add student to classroom: ${response.status}`);
	}
}

export async function removeStudentFromClassroom(
	teacherId: string,
	studentQID: string,
	classroomType: "classroom" | "group",
	classroomOrGroupId: string,
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<void> {
	const response = await fetch(
		`${host}/v1/appliances/${authHeaders.Device}/${classroomType}s/${classroomOrGroupId}/students/${studentQID}`,
		{
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
				user: teacherId,
				Authorization: authHeaders.Authorization,
				Device: authHeaders.Device,
			},
		}
	);

	if (!response.ok) {
		throw new Error(`Failed to remove student from classroom: ${response.status}`);
	}
}
